import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';
import { EditableCurrencyColumn } from './editable-currency-column';
import { ReadOnlyCurrencyColumn } from './read-only-currency-column';

import messages from '../../messages';

const shippingPaidColumnId = 'edit-shipping-paid-column';

const ShippingPaid = ({ value, updateRowProperty, row: { original } }) => {
  if (value.disabled) {
    return <ReadOnlyCurrencyColumn currencyValue={value} />;
  }
  return (
    <EditableCurrencyColumn
      columnId={shippingPaidColumnId}
      currencyValue={value}
      original={original}
      updateRowProperty={updateRowProperty}
    />
  );
};

ShippingPaid.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    disabled: PropTypes.bool,
  }).isRequired,
  updateRowProperty: PropTypes.func.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      [shippingPaidColumnId]: PropTypes.shape({
        code: PropTypes.string,
        value: PropTypes.number,
        disabled: PropTypes.bool,
      }),
    }).isRequired,
  }).isRequired,
};

const shippingPaidColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.shippingCost} />,
  accessor: shippingPaidColumnId,
  cell: ShippingPaid,
  width: 1.5,
});

export { shippingPaidColumnId, shippingPaidColumnDefinition };
